import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IBidderCommunityPageData} from "../../../models/IBidderCommunityPageData"


@Injectable({providedIn: 'root'})
export class BidderCommunityMenuService {

    private pageDataSource = new BehaviorSubject<IBidderCommunityPageData | null>(null);
    pageData$ = this.pageDataSource.asObservable();
    setPageData(pageData: IBidderCommunityPageData){
        this.pageDataSource.next(pageData);
    }

}